/* eslint-disable react/prop-types */
import Page from '../../../components/Page';
import useLocales from '../../../hooks/useLocales';
import Layout from '../../../layouts';
import HomeCar from '../../../sections/gplx/HomeCar';
import HomeMotoBike from '../../../sections/gplx/HomeMotoBike';
import { findLicenseTypesAPI } from '../../../service/gplx.licenseType.service';
import { licenseDataArray } from '../../../utils/licenses';

Index.getLayout = function getLayout(page) {
  return <Layout variant="main">{page}</Layout>;
};

export default function Index({ type, licenseTypes }) {
  const { translate } = useLocales();

  if (type === licenseDataArray[4][0])
    return (
      <Page title={translate('car.title')} description={translate('car.description')}>
        <HomeCar licenseTypes={licenseTypes} />
      </Page>
    );
  else
    return (
      <Page title={translate('bike.title')} description={translate('bike.description')}>
        <HomeMotoBike licenseTypes={licenseTypes} />
      </Page>
    );
}

export async function getStaticPaths() {
  const paths = licenseDataArray[4].map((type) => ({
    params: {
      type
    }
  }));

  return {
    paths,
    fallback: false,
  };
}

export async function getStaticProps({ params }) {
  const type = params.type;

  const search = { page: 0, size: 12, value: '%%', orders: [{ order: 'asc', property: 'orderNo' }] };
  // const { code, data: licenseTypes } = await findLicenseTypesAPI(search);

  // if (code !== "200") {
  //   return {
  //     notFound: true,
  //   };
  // }

  return {
    props: {
      type,
      licenseTypes:[]
    },
  };
}
